module.exports = __webpack_public_path__ + "img/gift-rule-Info_bg.c38151a4.png";